<template>
  <section id="reviews">
    <div class="row">
      <div class="col-12 col-lg-8 masthead--content" data-aos="fade-in">
        <div>
          <h3>Real Patients and their</h3><br>
          <h2 class="mb-5">REVIEWS</h2>
        </div>
      </div>

      <div class="container d-flex justify-content-center align-items-center" data-aos="fade-up">
        <div class="col-9 customPadding">
          <!-- Slider -->
          <div class="swiper frontpage-slider">
            <div class="swiper-wrapper" v-for="section in sections" :key="section.type">
              <div class="swiper-slide" v-for="entry in section.entries.reverse()" :key="entry.id">
                <div class="star">
                  <i class="fa-solid fa-star" v-for="star in entry.stars" :key="star"></i>
                </div>
                <h4>{{entry.title}}</h4>
                <p>
                  {{entry.description}}
                </p>
                <h4 class="inline-block">{{entry.name}}</h4>
              </div>
            </div>

            <div class="swiper-button-next">
              <i class="fa-thin fa-arrow-right"></i>
            </div>
          </div>

          <div class="col-12 view-all--link d-flex justify-content-end mt-4">
            <a href="testimonials" class="link link--underline">Read more reviews <i class="fa-regular fa-angles-right ms-3"></i></a>
          </div>
        </div>
      </div>
      <div class="col-12 bg--image"></div>
    </div>
  </section>
</template>

<script>
  const sections = require('../reviews.json')
  export default ({
    setup() {
      return {
        sections
      }
    },
  })
</script>